import { useGQLQuery } from 'hooks/useGQLQuery';
import { useParams } from 'react-router-dom';
import { GREENER_EYE_KEY, READ_GREENER_EYE } from 'services/gql/greenerEyes';

export function GreenerEyeBreadcrumb() {
  const { greenerEyeExtId } = useParams();
  const { data } = useGQLQuery(GREENER_EYE_KEY(greenerEyeExtId), READ_GREENER_EYE, {
    externalIdentifier: greenerEyeExtId,
  });
  const greenerEye = data?.greenerEye;

  return greenerEye ? `${greenerEye.externalIdentifier} (${greenerEye.name})` : greenerEyeExtId;
}
